import { CardDefaultUpdateDto } from '../dtos/card.dto';
import { Card, CardDefaultUpdate } from '../models/card';

/**
 * Map object from dto.
 * @param {object} dto DTO.
 * @returns {Card}
 */
function fromDto(dto) {
  return new Card({
    address: dto.address,
    approveCode: dto.approveCode,
    avsCode: dto.avsCode,
    cvv: dto.cvv,
    cvvCode: dto.cvvCode,
    expireMonth: dto.expireMonth,
    expireYear: dto.expireYear,
    name: dto.name,
    number: dto.number,
    paymentId: dto.paymentId,
    transactionId: dto.transactionId,
    type: dto.type,
    zip: dto.zip,
  });
}

/**
 * Map card to default update dto.
 * @param {CardDefaultUpdate} data Model data.
 * @returns {CardDefaultUpdateDto}
 */
function toDefaultUpdateDto(data) {
  return new CardDefaultUpdateDto({ payment_profile_id: data.paymentProfileId, group_admin_id: data.groupAdminId });
}

export const cardMapper = {
  fromDto,
  toDefaultUpdateDto,
};
